import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { IDataProviderFilter, IFilter } from 'core-components/types'

import { IFetchJbpBridgesParameters } from '../api/fetchJBPBridges'

export const getFetchJbpFilters = (filter: IDataProviderFilter): IFetchJbpBridgesParameters => {
  const filters = filter.filters as IFilter[]

  const ownerId = filters.find((it) => it.field === 'OwnerId')?.value as string
  if (!ownerId) {
    throw new Error('Provide `ownerId` for `spJBPBridges`')
  }

  const partnerId = filters.find((it) => it.field === 'PartnerId')?.value as string
  if (!partnerId) {
    throw new Error('Provide `partnerId` for `spJBPBridges`')
  }

  const programType = filters.find((it) => it.field === 'ProgramType')?.value as ProgramTypes
  if (!programType) {
    throw new Error('Provide `programType` for `spJBPBridges`')
  }

  const fYear = filters.find((it) => it.field === 'FYear')?.value as number
  if (!fYear) {
    throw new Error('Provide `fYear` for `spJBPBridges`')
  }

  const isRollup = filters.find((it) => it.field === 'IsRollup')?.value as unknown as boolean
  const geoFilter = filters.find((it) => it.field === 'GeoFilter')?.value as string

  return {
    ownerId,
    partnerId,
    programType,
    fYear,
    isRollup,
    geoFilter,
  }
}
